export function normalizeTurkishPhoneDigits(input: string): string {
  const digits = input.replace(/\D/g, '');
  if (digits.startsWith('90')) return digits;
  if (digits.startsWith('0')) return `90${digits.slice(1)}`;
  if (digits.length === 10) return `90${digits}`;
  return digits;
}

export function toTelHref(input: string): string {
  const digits = input.replace(/\D/g, '');
  if (digits.startsWith('90')) return `tel:+${digits}`;
  if (digits.startsWith('0')) return `tel:+90${digits.slice(1)}`;
  if (digits.length === 10) return `tel:+90${digits}`;
  return `tel:+${digits}`;
}

export function toWhatsAppHref(input: string): string {
  const normalized = normalizeTurkishPhoneDigits(input);
  return `https://wa.me/${normalized}`;
}


